import { Link } from "react-router";

import { Card } from "@/components/layout/Card";
import { Box } from "@/components/layout/flexbox";
import { Assignment } from "@/types/coaches";
import { CoachingUser } from "@/types/users";

import { GetStartedCard } from "./GetStartedCard";
import { YourCoaches } from "./YourCoaches";

interface CoachesProps {
  user: CoachingUser;
  assignments: Assignment[];
  viewAsCoach: boolean;
  workspaceId: string | null;
}

export function Coaches({
  user,
  assignments,
  viewAsCoach,
  workspaceId,
}: CoachesProps) {
  const coaches = (
    <YourCoaches
      user={user}
      assignments={assignments}
      viewAsCoach={viewAsCoach}
      workspaceId={workspaceId}
      style={{ flexGrow: 1 }}
    />
  );

  const STATES: Record<string, Record<string, () => React.ReactNode>> = {
    NO_COACH: {
      IS_COACH: () => (
        <Box mt={24}>
          <Card className="bas" elevation={1} css={{ px: 24 }}>
            Interested in booking services for yourself?{" "}
            <Link to="/match">Find a coach</Link>
          </Card>
        </Box>
      ),
      IS_CLIENT: () => {
        if (user.livePrograms?.data?.length) return null;
        return <GetStartedCard />;
      },
    },
    HAS_COACH: {
      IS_COACH: () => coaches,
      IS_CLIENT: () => coaches,
    },
  };
  let USER_TYPE = user.isAgent ? "IS_COACH" : "IS_CLIENT";
  const NUM_COACHES =
    !assignments || !assignments.length ? "NO_COACH" : "HAS_COACH";

  const Component = STATES[NUM_COACHES][USER_TYPE];
  if (!Component) return null;
  return <Component />;
}
